import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import useLogin from 'modules/oidc/useLogin';
import SuspenseFallback from './SuspenseFallback';

const LoginRedirect = () => {
	const { activeNavigator } = useAuth();
	const login = useLogin();

	useEffect(() => {
		// prevent calling signin while signing in
		if (activeNavigator) return;

		login();
	}, [login, activeNavigator]);

	return <SuspenseFallback />;
};

export default LoginRedirect;
